import * as React from "react"
import type { SVGProps } from "react"
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M7 14.71v6q0 .43-.29.72a1 1 0 0 1-.71.28 1 1 0 0 1-.71-.28A1 1 0 0 1 5 20.7v-15q0-.42.29-.7A1 1 0 0 1 6 4.7h7.18a1 1 0 0 1 .62.23 1 1 0 0 1 .35.57l.25 1.2H19q.42 0 .71.3.3.27.29.7v8q0 .43-.29.72a1 1 0 0 1-.71.28h-5.17a1 1 0 0 1-.63-.22 1 1 0 0 1-.35-.58l-.25-1.2zm7.65 0H18v-6h-4.42a1 1 0 0 1-.63-.22 1 1 0 0 1-.35-.58l-.25-1.2H7v6h6.43a1 1 0 0 1 .62.23 1 1 0 0 1 .35.57z" />
  </svg>
)
export default SvgFlag
